// extracted by mini-css-extract-plugin
export default {"layout":"Header_layout__TGTGv","box":"Header_box__V0FJ9","linkbraryLogo":"Header_linkbraryLogo__FOmyG","loginButton":"Header_loginButton__99QUE","fixed":"Header_fixed__O++Pp"};